//TODO: add actions to fetch reservation details, update status, etc.
import type { AppThunk } from 'typesafe-actions';
import { createAsyncAction } from 'typesafe-actions';

import generateLogger from '@travel/logger';

import { fetchAuthCodeAsync } from 'store/authCode/actions';

import type { AuthCodeError } from 'AuthCode-Types';
import { ERROR_401 } from 'constants/common';
import type { ReservationType } from 'constants/reservations';

import { getBookingDetailAPI } from './api';
import { ApiStatusMessage } from './enum';
const logger = generateLogger();

export const fetchBookingDetailAsync = createAsyncAction(
  'FETCH_BOOKING_DETAIL_REQUEST',
  'FETCH_BOOKING_DETAIL_SUCCESS',
  'FETCH_BOOKING_DETAIL_FAILURE',
)<string, any, any>();

export const fetchBookingDetail =
  (bookingId: string, type?: ReservationType): AppThunk =>
  async (dispatch, getState, { apiClient }) => {
    dispatch(fetchBookingDetailAsync.request(bookingId));
    const { authCode } = getState();
    const { token } = authCode.item;

    const params = {
      bookingId: bookingId, // Use the bookingId from the request
      type: type,
    };

    // do not fetch if there is no token
    if (!token) return;

    try {
      const response = await getBookingDetailAPI(apiClient, params);
      if (response.Header.Status === ApiStatusMessage.SUCCESS) {
        dispatch(fetchBookingDetailAsync.success(response.Body));
      } else {
        logger.error('error', response);
        dispatch(fetchBookingDetailAsync.failure(response));
      }
    } catch (error) {
      if ((error as { status: number }).status === ERROR_401) {
        dispatch(fetchAuthCodeAsync.failure(error as AuthCodeError));
      } else {
        logger.error(error);
        dispatch(fetchBookingDetailAsync.failure(error));
      }
    }
  };
